/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_H2Inputs */

const es_landing_cta_h2 = /** @type {(inputs: Landing_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu barco de toda la vida, por fin rentable.`)
};

const gl_landing_cta_h2 = /** @type {(inputs: Landing_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu barco de toda a vida, por fin rendible.`)
};

const en_landing_cta_h2 = /** @type {(inputs: Landing_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your lifelong boat, finally paying its way.`)
};

/**
* | output |
* | --- |
* | "Your lifelong boat, finally paying its way." |
*
* @param {Landing_Cta_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_h2 = /** @type {((inputs?: Landing_Cta_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_cta_h2(inputs)
	if (locale === "en") return en_landing_cta_h2(inputs)
	return es_landing_cta_h2(inputs)
});